import { AuthActions } from "./AuthActions";

export class AuthUser {
  token!: string;
  user!: {
    address: string;
    bio: string;
    companyName: string;
    email: string;
    fullName: string;
    gender: boolean;
    hiringDate: Date;
    id: number;
    jobId: number;
    jobName: string;
    password: string;
    phone: string;
    tag: string;
    tenantId: number;
    tenantName: string;
    tntStatus: string;
    userInfo: string;
    userName: string;
    verificationDate: Date;
    userActionList: AuthActions[];
    dateFormat: string;
    timeByMinutes: number;
    organizationId: number;
    userId: number;
    imagePath: string;
    reportTo: string;
    tempPass: string;
  };
  status!:boolean;
  message?: string;
}
